import React from 'react';
import './knowService.css';
import ImagePolygonItem from '../../ImagePolygon/ImagePolygonItem';
import { Link } from 'react-router-dom';
import { Parallax } from 'react-scroll-parallax';

const KnowService = ({ content }) => {
    return (
        <div className="industrial-services-container container">
            <div className="row services-section">
                <div className="col-md-8">
                    <div className="text-content">
                        <h4 style={{ color: content.backgroundColor }}>
                            {content.header}
                        </h4>
                        <h2>
                            {content.title} <br />
                            <span>{content.subtitle}</span>
                        </h2>
                        <p>{content.description}</p>
                        <Link to={content.buttonLink} className="projects-link btn-general">
                            {content.button}
                        </Link>
                    </div>
                </div>
                <div className="col-md-4" style={{ position: 'relative' }}>
                    {/* Parallax en la imagen principal */}
                    <ImagePolygonItem
                        src={content.image}
                        clipPath="polygon(84% 59%, 18% 100%, 0 70%, 8% 45%, 81% 0, 100% 22%)"
                        style={{
                            zIndex: '2',
                            width: "100%",
                            height: "600px",
                            filter: "grayscale(100%)",
                            right: "50px",
                            bottom: "50px"
                        }}
                    />
                    <Parallax speed={-5}>
                        <div
                            style={{
                                backgroundColor: content.backgroundColor,
                                clipPath: "polygon(84% 59%, 18% 100%, 0 70%, 8% 45%, 81% 0, 100% 22%)",
                                width: '200px',
                                height: '400px',
                                position: 'absolute',
                                bottom: '0px',
                                right: '0px',
                                zIndex: '1'
                            }}
                        ></div>
                    </Parallax>
                </div>
            </div>
            <div className="row row-mr">
                <div className="col-md-4 col-content-float">
                    <div className="specialized-team">
                        <div
                            style={{
                                position: 'absolute',
                                width: '2px',
                                height: '150px',
                                backgroundColor: content.backgroundColor,
                                transform: 'rotate(45deg)',
                                bottom: '20px',
                                left: '80px',
                            }}
                        ></div>
                        <div
                            style={{
                                position: 'absolute',
                                width: '2px',
                                height: '150px',
                                backgroundColor: content.backgroundColor,
                                transform: 'rotate(45deg)',
                                top: '20px',
                                right: '50px',
                            }}
                        ></div>
                        <h2>
                            <span>{content.specializedHeader}</span> <br />
                            {content.specializedTitle} <br />
                            {content.specializedSubtitle}
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KnowService;
